import { render } from "./activity.vue?vue&type=template&id=0d830f68&lang=pug&bindings={}"
import script from "./activity.vue?vue&type=script&lang=js"
export * from "./activity.vue?vue&type=script&lang=js"

import "./activity.vue?vue&type=style&index=0&lang=sass"
script.render = render

export default script